import { render } from "./TaskModal.vue?vue&type=template&id=d815bd8e&scoped=true"
import script from "./TaskModal.vue?vue&type=script&lang=js"
export * from "./TaskModal.vue?vue&type=script&lang=js"

import "./TaskModal.vue?vue&type=style&index=0&id=d815bd8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d815bd8e"]])

export default __exports__